export const getBlackTypesOptions = (array) => {
  const blackOptions = [];
  if (array) {
    array.map((item) => blackOptions.push({ value: item.value, label: item.name }));
  }

  return blackOptions;
};
